/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var MoreActionVerticalIcon = createIcon("MoreActionVerticalIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M28 0H2a2 2 0 00-2 2v26a2 2 0 002 2h26a2 2 0 002-2V2a2 2 0 00-2-2Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 22a2 2 0 110 4 2 2 0 010-4Zm0-9a2 2 0 110 4 2 2 0 010-4Zm0-9a2 2 0 110 4 2 2 0 010-4Z",
    fill: "#0045DB"
  }));
}, {});